import React from 'react';

import { IconButton, InputAdornment, TextField, Typography } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import SearchIcon from '@material-ui/icons/Search';

import useStyles from './DashboardHeader.styles';

export default function DashboardHeader({
  currentDate,
  updatedAt,
  searchTerm,
  searchPlaceholder,
  onSearchChange,
  onSearchSubmit,
  onRefresh,
}) {
  const classes = useStyles();

  return (
    <div className={classes.header}>
      <div>
        <Typography className={classes.title}>{currentDate}</Typography>
        <div className={classes.updatedLine}>
          <Typography className={classes.updated}>
            Atualizado às <strong>{updatedAt}</strong>
          </Typography>
          <IconButton
            className={classes.refreshButton}
            onClick={onRefresh}
            aria-label="Atualizar horário"
          >
            <RefreshIcon className={classes.refreshIcon} />
          </IconButton>
        </div>
      </div>
      <div className={classes.searchActions}>
        <TextField
          className={classes.search}
          variant="outlined"
          placeholder={searchPlaceholder}
          value={searchTerm}
          onChange={(event) => onSearchChange(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              onSearchSubmit();
            }
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={onSearchSubmit}
                  edge="end"
                  aria-label="Buscar em todos os pedidos"
                >
                  <SearchIcon className={classes.searchIcon} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </div>
    </div>
  );
}
